import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { casePath } from "../i18n/route";
import { CountUp } from "../motion/CountUp";

export const WorkCard = ({ item, lang, visitLabel, compact = false, testid }) => (
  <Link
    to={casePath(item.slug, lang)}
    data-testid={testid}
    className="group flex flex-col min-w-0 bg-white border border-[#E5E3DB] p-7 md:p-8 hover:border-navy hover:-translate-y-[3px] hover:shadow-[0_18px_40px_-24px_rgba(35,39,80,0.35)] motion-reduce:hover:translate-y-0 transition-[transform,box-shadow,border-color] duration-300"
  >
    {item.badge && (
      <span data-testid={`${testid}-badge`} className="self-start mb-4 px-3 py-1 bg-green text-navy text-[10px] tracking-widest uppercase rounded-full">
        {item.badge}
      </span>
    )}
    <div className="flex items-start justify-between gap-4 mb-6">
      <div className="eyebrow text-ink">{item.client}</div>
      <ArrowRight size={18} className="shrink-0 text-ink transition-transform group-hover:translate-x-1 group-hover:text-navy" />
    </div>
    <div className={`heading-display mb-2 break-words ${compact ? "text-[clamp(1.75rem,3vw,2.25rem)]" : "text-[clamp(2rem,3.4vw,3rem)]"}`}>
      <CountUp text={item.metric} testid={testid && `${testid}-metric`} />
    </div>
    <div className="text-sm text-ink mb-6">{item.label}</div>
    {!compact && (
      <>
        <div className="divider-line mb-5" />
        <div className="text-xs text-ink leading-relaxed">{item.detail}</div>
      </>
    )}
    <div className="mt-auto pt-6 inline-flex items-center gap-1 text-xs tracking-wide text-navy group-hover:gap-2 transition-all">
      {visitLabel} <ArrowRight size={14} />
    </div>
  </Link>
);
